<template>
  <div class="sunhub">
    <div class="widget">
      <div class="widget-body">
        <div class="d-flex justify-content-between align-items-center">
          <div class="state">
            <h4>
              Sunhub CRM
              <small v-if="!activeIntegration">(Inativo)</small>
            </h4>
          </div>
          <div class="icon">
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon add-margin-right="20px" />
              <div v-if="activeIntegration">
                <font
                  title="Configurações"
                  size="6"
                  color="black"
                  @click.prevent="toogleUpdateIntegration()">
                  <i class="ik ik-settings" />
                </font>
              </div>
              <div v-else>
                <font
                  title="Configurações"
                  size="6"
                  color="gray">
                  <i class="ik ik-settings" />
                </font>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
          <small class="text-small mt-10 d-block">
            <toggle-button
              tag="sunhub"
              class="mb-1"
              :width="90"
              :height="30"
              :font-size="15"
              :value="activeIntegration"
              :sync="true"
              :labels="{checked: 'Ativo', unchecked: 'Ativar'}"
              @change="toogleIntegration" />
          </small>
          <!-- <font
            title="Tutorial"
            size="6"
            color="black"
            @click.prevent="openTutorial">
            <i class="ik ik-youtube" />
          </font> -->
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="confirmDelete"
      ref="confirmDelete"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <h4 class="modal-title">Você tem certeza que deseja remover a integração com o Sunhub CRM?</h4>
          </div>
          <div class="modal-footer">
            <div class="buttons">
              <button
                type="button"
                class="btn btn-outline-secondary"
                data-dismiss="modal">Não</button>
              <button
                type="button"
                class="btn btn-primary"
                @click.prevent="deleteIntegration">Sim</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="updateIntegration"
      ref="updateIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Configurar Sunhub CRM</h4>
            <div class="d-flex align-items-center">
              <artificial-intelligence-icon />
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
          </div>
          <div class="modal-body">
              <ErrorAlert :error="errorAlert" />
            <p class="text-center">
              Para gerar/copiar seu acesso à API do Sunhub
              <a
                class="link"
                href="https://crm.sunhub.app.br/administration/integrationusers"
                target="_blank">
                clique aqui
              </a>
            </p>
            <p class="text-center">
              Para mais informações sobre como gerar seu acesso à API do Sunhub
              <a
                class="link"
                href="https://suporte.ploomes.com/pt-BR/articles/5452438-como-obter-acesso-a-api-do-ploomes"
                target="_blank">
                clique aqui
              </a>
            </p>
            <p class="text-center">
              <b>Observação: </b><br>
              O token de acesso à API do Sunhub é gerado apenas por usuários administradores.<br>
              O Perfil do usuário de integração deve ter permissão de administrador.
            </p>
            <div class="form-group row">
              <label
                for="sunhubUserKey"
                class="col-sm-4 col-form-label">Token de acesso à API</label>
              <div class="col-sm-8">
                <input
                  id="sunhubUserKey"
                  type="text"
                  class="form-control"
                  v-model="sunhubUserKey">
              </div>
            </div>
            <div class="modal-footer">
              <div class="buttons">
                <button
                  type="button"
                  class="btn btn-primary"
                  :disabled="!configReady"
                  @click.prevent="saveIntegration">{{ labelSubmit }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="successIntegration"
      ref="successIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Sunhub CRM atualizada com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="uninstallIntegration"
      ref="uninstallIntegration"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-sm modal-dialog-centered"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <h5 class="modal-title">Integração Sunhub CRM removida com sucesso!</h5>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-secondary"
              data-dismiss="modal">OK</button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      tabindex="-1"
      role="dialog"
      id="tutorialSunhub"
      ref="tutorialSunhub"
      data-keyboard="false"
      data-backdrop="static"
      aria-hidden="true">
      <div
        class="modal-dialog modal-dialog-centered modal-lg"
        role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Tutorial Sunhub CRM</h4>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <iframe
              width="760"
              height="420"
              src=""
              title="Tutorial Sunhub CRM"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" />
          </div>
          <div class="modal-footer" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import loopback from '@/services/loopback'
import ArtificialIntelligenceIcon from '@/components/Common/ArtificialIntelligenceIcon.vue'
export default {
  name: 'IntegrationSunhub',
  components: {
    ArtificialIntelligenceIcon
  },
  data () {
    return {
      error: null,
      integration: null,
      configReady: false,
      sunhubUserKey: null
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadIntegration()
    })
  },
  methods: {
    loadIntegration () {
      return new Promise(resolve => {
        return loopback
          .get(`/integrations?filter[where][gateway]=sunhub`)
          .then(integrations => {
            this.integration = integrations.pop()
            if (this.integration && this.integration.metadata) {
              if (this.integration.metadata.userKey) this.sunhubUserKey = this.integration.metadata.userKey
            }
            return resolve()
          })
          .catch(err => { this.$emit('onError', err) })
      })
    },
    saveIntegration () {
      return new Promise((resolve, reject) => {
        this.error = null
        if (!this.configReady) {
          this.error = 'Houve um erro ao salvar a integração. Por favor, tente novamente.'
          return resolve()
        }
        if (this.sunhubUserKey) {
          this.tokenValidator(false).then(users => {
            const integrationParams = {
              gateway: 'sunhub',
              webhook: true,
              webhookConstraint: {
                metadata: {
                  api4comGateway: 'sunhub'
                }
              },
              metadata: {
                userKey: this.sunhubUserKey,
                webhookUrl: `${process.env.API4COM_BASE_URL_API}${process.env.API4COM_VERSION_API}/integrations/webhook`,
                webhookVersion: 'v1.4',
                webhookTypes: ['channel-hangup']
              }
            }
            if (this.integration) integrationParams.id = this.integration.id
            if (this.integration && this.integration.metadata) integrationParams.metadata = Object.assign(this.integration.metadata, integrationParams.metadata)
            if (this.sunhubUserKey) integrationParams.metadata.userKey = this.sunhubUserKey
            else delete integrationParams.metadata.userKey
            loopback
              .patch('/integrations', integrationParams)
              .then(integration => {
                this.integration = integration
                this.configReady = true
                $(this.$refs.updateIntegration).modal('hide')
                $(this.$refs.successIntegration).modal('show')
                return resolve()
              })
              .catch(err => {
                this.error = err
              })
          }).catch(err => {
            this.error = 'Falha na validação do token. Por favor, verifique o seu token e tente novamente.'
            reject(err)
          })
        } else {
          this.configReady = false
          this.error = 'O token não pode estar vazio.'
        }
      })
    },
    toogleIntegration (event) {
      if (event.value === true) {
        $(this.$refs.updateIntegration).modal('show')
      } else {
        $(this.$refs.confirmDelete).modal('show')
      }
    },
    toogleUpdateIntegration () {
      this.error = null
      this.configReady = true
      $(this.$refs.updateIntegration).modal('show')
    },
    deleteIntegration () {
      if (!this.integration) return
      loopback
        .delete(`/integrations/${this.integration.id}`)
        .then(_ => {
          this.integration = null
          this.configReady = false
          this.sunhubUserKey = null
          $(this.$refs.uninstallIntegration).modal('show')
        })
        .finally(_ => {
          $(this.$refs.confirmDelete).modal('hide')
        })
        .catch(err => { this.$emit('onError', err) })
    },
    tokenValidator () {
      if (this.sunhubUserKey) {
        return loopback
          .get(`/integrations/sunhub/users?userKey=${this.sunhubUserKey}`)
          .then(users => {
            if (users && users.length > 0) {
              this.configReady = true
              this.error = null
            } else {
              this.configReady = false
              this.error = 'Token inválido'
            }
          })
          .catch(() => {
            this.configReady = false
            this.error = 'Token inválido'
          })
      }
    },
    errorHandle (err) {
      console.error(err)
      this.error = 'Houve um problema com a autenticação da integração. Talvez seja necessário reinstalar essa integração.'
    },
    openTutorial () {
      $(this.$refs.tutorialSunhub).modal('show')
    }
  },
  computed: {
    // TEL-2243: estas telas guardam `error` ora como string escrita por elas, ora
    // como o erro cru do transporte — que em `v-html` virava `[object Object]`.
    // O ErrorAlert aceita os dois formatos; aqui so montamos o envelope.
    errorAlert () {
      if (!this.error) return null
      return typeof this.error === 'string' ? { lines: [this.error] } : this.error
    },
    activeIntegration () {
      return this.integration && this.integration.gateway === 'sunhub'
    },
    labelSubmit () {
      return this.activeIntegration ? 'Salvar' : 'Ativar'
    }
  },
  watch: {
    sunhubUserKey: function (sunhubUserKey) {
      if (sunhubUserKey) this.tokenValidator()
    }
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/Integration/Sunhub.vue